import React from 'react';
import { Facebook, Linkedin, Youtube, Instagram } from 'lucide-react';
import './ExploreLinks.css';

const ExploreLinksSection = () => {
  return (
    <div className="explore-links-section">
      <div className="explore-links-container">

        

        {/* Explore Links */}
       <div className="explore-links">
  <h3 className="explore-section-title">Explore</h3>
  <a href="/guidelines" className="explore-nav-link">Community Guidelines</a>
  <a 
    href="https://www.africaquantumsummit.com" 
    className="explore-nav-link" 
    target="_blank" 
    rel="noopener noreferrer"
  >
    Africa Quantum Summit
  </a>
  <a 
    href="https://aqen-quantum.vercel.app" 
    className="explore-nav-link" 
    target="_blank" 
    rel="noopener noreferrer"
  >
    Africa Quantum Education Network (AQEN)
  </a>
</div>


        {/* Explore Links */}
        <div className="explore-links">
          <h3 className="explore-section-title">Engage Us</h3>
          <a href="/team" className="explore-nav-link">Meet the Team</a>
          <a href="/bootcamps" className="explore-nav-link">Our Bootcamps</a>
          <a href="/contact-us" className="explore-nav-link">Get in Touch</a>
        </div>

        {/* Social Media Icons */}
        <div className="social-media-section">
          <h3 className="explore-section-title">Connect With Us</h3>

          <div className="social-icons">
            <a 
              href="https://www.facebook.com/quantumke.org" 
              className="social-icon"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Facebook className="icon" />
            </a>
            <a 
              href="https://x.com/Quantumke_org" 
              className="social-icon"
              target="_blank"
              rel="noopener noreferrer"
            >
              {/* Custom X (Twitter) Icon */}
              <svg className="icon" viewBox="0 0 24 24" fill="currentColor">
                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
              </svg>
            </a>
            <a 
              href="https://www.instagram.com/quantumke_community" 
              className="social-icon"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Instagram className="icon" />
            </a>
            <a 
              href="https://www.tiktok.com/@quantumke_org" 
              className="social-icon"
              target="_blank"
              rel="noopener noreferrer"
            >
              {/* Custom TikTok Icon */}
              <svg className="icon" viewBox="0 0 24 24" fill="currentColor">
                <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-.88-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
              </svg>
            </a>
            <a 
              href="https://www.linkedin.com/company/one-quantum-kenya" 
              className="social-icon"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Linkedin className="icon" />
            </a>
            <a 
              href="https://www.youtube.com/@QuantumkeCommunity" 
              className="social-icon"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Youtube className="icon" />
            </a>
          </div>
          <div className="email-link">
          <a 
            href="mailto:info@quantumke.org" 
            className="email-link"
          >
            Email Us: info@quantumke.org
          </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExploreLinksSection;